import config from './Amplify';
import {
    getAccessToken,
    getIdToken,
    getUserIfSignedIn,
    signOut,
} from './amplifyAuthAdapter';

// TODO: concat this two Class into one
class GMGAuth {
    static #instance = undefined;

    static getInstance() {
        if (!GMGAuth.#instance) {
            GMGAuth.#instance = new GMGHostedAuth();
        }
        return GMGAuth.#instance;
    }

    async getUserIfSignedIn() {
        return await getUserIfSignedIn();
    }
}

class GMGHostedAuth extends GMGAuth {
    async getAccessToken() {
        return await getAccessToken();
    }

    async getIdToken() {
        return await getIdToken();
    }

    async signOut() {
        await signOut();
        this.#performSsoLogout();
    }

    // TODO: test whether it is still needed
    #performSsoLogout() {
        // config.Auth is now the Amplify v6 Auth.Cognito config. The logout URL
        // still needs the original hosted-UI metadata preserved as GMGHostedAuth.
        const logoutUrl = new URL(`https://${config.GMGHostedAuth.oauth.domain}/logout`);
        logoutUrl.searchParams.set('client_id', config.GMGHostedAuth.userPoolWebClientId);
        logoutUrl.searchParams.set('logout_uri', config.GMGHostedAuth.oauth.redirectSignOut);
        document.location = logoutUrl.toString();
    }
}

export { GMGAuth };
